import {
  ArchivedEntry,
  AssistantAnswersConfirmedEntry,
  BeforeAndAfterEntry,
  CreatedEntry,
  EmptyValue,
  HistoryEntries,
  HistoryEntryMetadata,
  MultipleValues,
  SnapshotValueText,
  UnarchivedEntry,
} from "./HistoryEntries";

export const DynamicHistory = {
  Entries: HistoryEntries,
  ArchivedEntry,
  AssistantAnswersConfirmedEntry,
  UnarchivedEntry,
  CreatedEntry,
  BeforeAndAfterEntry,
  Metadata: HistoryEntryMetadata,
  SnapshotValueText,
  MultipleValues,
  EmptyValue,
};
